$(document).ready(async function () {
	setupProductCompareTable();
	const promises = [
		getAlertBarContent(),
		getAlertDetails(),
		getHeroBanner(),
		getHeroPromoBar(),
		getSideBySideBlock(),
		setupProductsWizard(),
		getHelocApplicationGeoRegion(),
	];
	await Promise.allSettled(promises);
	setupGeotargetedOaoLinks();
});

function hideAlertCookie(cookieKey) {
	var decodedCookie = decodeURIComponent(document.cookie);
	var cookie = decodedCookie.split(';');
	var status = '';

	for (var i = 0; i < cookie.length; i++) {
		if (cookie[i].trim().indexOf(cookieKey) != -1) {
			status = cookie[i].trim();
		}
	}

	if (status == cookieKey+'=false') {
		alertCookieKey = cookieKey;
		return true;
	} else {
		return false;
	}

}

function getHeroBanner(){
	return new Promise((resolve, reject) => {
		if($('.hero-banner-block-wrapper').length){
			$.ajax({
				url: ajaxurl,
				type: 'GET',
				data: {
					'action': 'get_ajax_hero',
					'pid': geot.pid
				},
				dataType: "html",
				success: function(response) {
					$('.hero-banner-block-wrapper').append(response);
					resolve();
				},
				error: function (error) {
					$('.hero-banner-block-wrapper').append(generateFallbackHeroLayout());
					resolve();
				}
			});
		} else {
			reject();
		}
	});
}

function getHeroPromoBar(){
	if($('.hero-promo-bar-block-wrapper').length){
		$.ajax({
			url: ajaxurl,
			type: 'GET',
			data: {
				'action': 'get_ajax_promo_bar',
				'pid': geot.pid
			},
			dataType: "html",
			success: function(response) {
				$('.hero-promo-bar-block-wrapper').append(response);
			}
		});
	}
}

function getSideBySideBlock(){
	return new Promise((resolve, reject) => {
		if($('.side-by-side-block-wrapper').length){
			const blockId = $('.side-by-side-block-wrapper')[0].id;
			$.ajax({
				url: ajaxurl,
				type: 'GET',
				data: {
					'action': 'get_ajax_side_by_side',
					'blockId' : blockId,
					'pid': geot.pid
				},
				dataType: "html",
				success: function(response) {
					$('.side-by-side-block-wrapper').append(response);
					resolve();
				},
				error: function (error) {
					reject();
				}
			});
		} else {
			reject();
		}
	});
}

function getAlertBarContent(){
	return new Promise((resolve, reject) => {
		$.ajax({
			url: ajaxurl,
			type: 'GET',
			data: {
				'action': 'get_alert_bar_content'
			},
			dataType: "json",
			success: function(response) {
				if(response && response.content){
					if(!hideAlertCookie(response.id)){
						const myAlert = document.getElementById('alertMessage')
						myAlert.addEventListener('closed.bs.alert', event => {
							document.cookie = response.id+'=false;path=/';
							$('#alertMessageWrapper').attr( "class","alert-off");
						});
						$('#alertMessageWrapper').attr( "class",'alert-on '+response.alert_type);
						$('#alertMessageIcon').addClass(response.alert_type_icon);
						$('#alertMessageContent').append( response.content);
					}
				}
				resolve();
			},
			error: function (error){
				reject();
			}
		});
	});
}

function getAlertDetails(){
	return new Promise((resolve, reject) => {
		if($('.alert-details-block-wrapper').length){
			$.ajax({
				url: ajaxurl,
				type: 'GET',
				data: {
					'action': 'get_alert_details_content'
				},
				dataType: "json",
				success: function(response) {
					if(response && response.content){
						$('.alert-details-block-row').addClass(response.alert_type);
						var alertDetailsTitle = document.createElement("h3");
						if(response.title) alertDetailsTitle.textContent = response.title;
						var alertDetailsBody = document.createElement("p");
						if(response.content) alertDetailsBody = response.content;
						$('.alert-details-block-row').append(alertDetailsTitle);
						$('.alert-details-block-row').append(alertDetailsBody);
					}
					resolve();
				},
				error: function(error) {
					reject();
				}
			});
		} else {
			reject();
		}
	});
}

function setupProductsWizard(){
	if($('.wizard-block').length){
		document.getElementById('product-wizard-want-to').addEventListener("change", async function () {
			await getWizardProducts();
			setupGeotargetedOaoLinks('.wizard-block');
		});
		document.getElementById('product-wizard-for').addEventListener("change", async function () {
			await getWizardProducts();
			setupGeotargetedOaoLinks('.wizard-block');
		});
		document.getElementById('product-wizard-residency').addEventListener("change", async function () {
			await getWizardProducts();
			setupGeotargetedOaoLinks('.wizard-block');
		});
		return getWizardProducts();
	}else{
		return Promise.reject();
	}
}

function getWizardProducts(){
	return new Promise((resolve, reject) => {
		if($('.wizard-block').length){
			var wantTo = document.getElementById('product-wizard-want-to').value;
			var forMy = document.getElementById('product-wizard-for').value;
			var residency = document.getElementById('product-wizard-residency').value;
			$.ajax({
				url: ajaxurl,
				type: 'GET',
				data: {
					'action': 'get_wizard_products',
					'purpose': wantTo,
					'for': forMy,
					'residency': residency,
				},
				dataType: "html",
				success: function(response) {
					const wizardProductList = $('.wizard-product-list');
					wizardProductList.empty();
					wizardProductList.append(response);
					resolve();
				},
				error: function (error) {
					reject();
				}
			});
		}else{
			reject();
		}
	});
}

function applyHelocApplicationBranchResponse(response){
	if(!response || typeof response.region === 'undefined'){
		return;
	}

	$('.heloc-application-block').each(function () {
		const block = this;
		const bankingCenterSelect = block.querySelector('.heloc-application-banking-center select');

		block.setAttribute('data-heloc-geo-region', response.region);

		if(response.branchId && response.branchName && bankingCenterSelect){
			let matchedOption = Array.from(bankingCenterSelect.options).find(function (option) {
				return option.value === response.branchId;
			});

			if(!matchedOption){
				matchedOption = new Option(response.branchName, response.branchId);
				bankingCenterSelect.add(matchedOption);
			}else{
				matchedOption.textContent = response.branchName;
			}

			bankingCenterSelect.value = response.branchId;
			bankingCenterSelect.dispatchEvent(new Event('change', { bubbles: true }));
		}
	});
}

function getBrowserHelocApplicationPosition(){
	return new Promise((resolve, reject) => {
		if(!navigator.geolocation){
			reject();
			return;
		}

		navigator.geolocation.getCurrentPosition(resolve, reject, {
			enableHighAccuracy: true,
			timeout: 60000,
			maximumAge: 300000,
		});
	});
}

function getHelocApplicationNearestBranchByCoordinates(position){
	return new Promise((resolve, reject) => {
		if(!position || !position.coords){
			reject();
			return;
		}

		$.ajax({
			url: ajaxurl,
			type: 'POST',
			data: {
				'action': 'get_heloc_application_nearest_branch_by_coordinates',
				'latitude': position.coords.latitude,
				'longitude': position.coords.longitude,
				'accuracy': position.coords.accuracy,
			},
			dataType: "json",
			success: function(response) {
				if(response && response.branchId && response.branchName){
					applyHelocApplicationBranchResponse({
						region: 'non-virtual-branch',
						branchName: response.branchName,
						branchId: response.branchId,
					});
				}
				resolve();
			},
			error: function (error) {
				reject();
			}
		});
	});
}

function getHelocApplicationGeoRegion(){
	return new Promise((resolve, reject) => {
		if($('.heloc-application-block').length){
			$.ajax({
				url: ajaxurl,
				type: 'GET',
				data: {
					'action': 'get_heloc_application_geo_region'
				},
				dataType: "json",
				success: async function(response) {
					applyHelocApplicationBranchResponse(response);

					if(response && response.region === 'non-virtual-branch'){
						try {
							const browserPosition = await getBrowserHelocApplicationPosition();
							await getHelocApplicationNearestBranchByCoordinates(browserPosition);
						}catch(error) {
							// Browser geolocation is optional. Keep the server-side result when unavailable.
						}
					}
					resolve();
				},
				error: function (error) {
					reject();
				}
			});
		}else{
			reject();
		}
	});
}

function setupProductCompareTable(){
	if($('.product-compare-block').length){
		document.getElementById('product-compare-table-residency').addEventListener("change", function(event, value) {
			var residency = document.getElementById('product-compare-table-residency').value;
			if(residency === 'us-resident'){
				document.getElementById('product-compare-table-responsive-wrapper-us-products').classList.remove('d-none');
				document.getElementById('product-compare-table-responsive-wrapper-non-us-products').classList.add('d-none');
			} else if (residency === 'non-us-resident'){
				document.getElementById('product-compare-table-responsive-wrapper-non-us-products').classList.remove('d-none');
				document.getElementById('product-compare-table-responsive-wrapper-us-products').classList.add('d-none');
			}else{
				console.error('Product compare residency option invalid');
			}
		});
	}
}

function setupGeotargetedOaoLinks(context){
	var scope = document;
	if(context) scope = document.querySelector(context);
	var links = scope.querySelectorAll("a[href^='https://apply.amerantbank.com/openaccount'],a[href^='https://b067010509.cc-account-open.online-banking-services.com/openaccount']");
	let pidArray = [];
	links.forEach(link => {
		const urlParams = new URL(link).searchParams;
		const pid = urlParams.get('externalProductIds');
		pidArray.push(pid);
	});
	if(pidArray.length > 0){
		$.ajax({
			url: ajaxurl,
			type: 'GET',
			data: {
				'action': 'get_oao_links_mapping',
				'pids': JSON.stringify([...new Set(pidArray)])
			},
			dataType: "json",
			success: function(response) {
				links.forEach(link => {
					const linkUrl = new URL(link);
					const pid = linkUrl.searchParams.get('externalProductIds');
					for(const mapping of response){
						if(mapping.oofPid === pid){
							if(mapping.localizedPid) linkUrl.searchParams.set('externalProductIds',mapping.localizedPid);
							if(mapping.externalState) linkUrl.searchParams.set('externalState',mapping.externalState);
							if(mapping.marketAreaPricingCd) linkUrl.searchParams.set('marketAreaPricingCd',mapping.marketAreaPricingCd);
							link.href = linkUrl.origin + linkUrl.pathname + linkUrl.search;
							break;
						}
					}
				});
			},
			error: function (error) {
				console.error('error in oao mapping',error);
			}
		});
	}
}

function generateFallbackHeroLayout() {
	if(heroFallbackBg && heroFallbackMobileBg && heroFallbackImage && heroFallbackMobileImage){
		return `
		<div class="hero-banner-block row">
			<div id="heroBannerCarousel" class="carousel slide" data-bs-ride="carousel" aria-roledescription="carousel">
				<div class="carousel-inner">
					<div class="carousel-item carousel-item ` + heroFallbackBg + ` ` + heroFallbackMobileBg + ` active" aria-roledescription="slide" aria-label="Carousel slide 1 of 1">
						<div class="carousel-background-wrapper lazy-bg" style="background-image: url('` + heroFallbackImage + `');">
							<div class="container carousel-container">
								<div class="row carousel-item-row">
									<div class="col-12 d-lg-none carousel-mobile-image">
										<img src="` + heroFallbackMobileImage + `" class="img-fluid" loading="lazy">
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>`;
	}else{
		return `<div></div>`;
	}
}
